export const agricultureSubMenus = [
  {
    link: "#about",
    label: "About",
  },
  {
    link: "#product-range",
    label: "Product Range",
  },
  {
    link: "#our-team",
    label: "Our Team",
  },
  {
    link: "#dates-grower",
    label: "Dates Grower",
  },
  {
    link: "#king-of-dates",
    label: "King of Dates",
  },
  {
    link: "#fair-trade-&-quality",
    label: "Fair Trade & Quality",
  },
  {
    link: "#packaging-option",
    label: "Packaging Option",
  },
  {
    link: "#our-brands",
    label: "Our Brands",
  },
];
